import styled from 'styled-components'

const HeaderTitle = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	font-size: 20px;
	letter-spacing: -.02em;
	font-weight: 700;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export default HeaderTitle